
export class TimeSlot {

  fromHour: number;
  fromMinutes: number;
  toHour: number;
  toMinutes: number;

  constructor(fromHour: number, fromMinutes: number, toHour: number, toMinutes: number) {

    this.fromHour = fromHour;
    this.fromMinutes = fromMinutes;
    this.toHour = toHour;
    this.toMinutes = toMinutes;
  }

  getFromHourMin() {
    let fromH; 
    let fromM; 
    this.fromHour < 10 ? fromH = "0" + this.fromHour : fromH = this.fromHour; 
    this.fromMinutes < 10 ? fromM = "0" + this.fromMinutes : fromM = this.fromMinutes; 
    return fromH + ":" + fromM;
  }

  getToHourMin() {
    let toH; 
    let toM; 
    this.toHour < 10 ? toH = "0" + this.toHour : toH = this.toHour;  
    this.toMinutes < 10 ? toM = "0" + this.toMinutes : toM = this.toMinutes;
    return toH + ":" + toM;
  }
  
}
